import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { Translate } from 'react-localize-redux';
import { CallHistoryMethodAction, push } from 'connected-react-router';

import styled from 'styled-components';

import { ReleaseStatus } from '@common/types/release/relase-status';
import { ConfirmTakedownRelease } from '@webapp/store/release/action-creators';

import Typography from '@components/basics/typography';
import Button from '@components/actions/button';
import NavbarItemAvatarCtrl from '../navbar-items/navbar-item-avatar';

interface NavbarActionsUpgradeCtrlProps {
  className?: string;
  artistId?: string;
  releaseId?: string;
  disableTakeDown?: boolean;
  isMobile: boolean;
  releaseStatus: ReleaseStatus;
  releaseTitle: string;
  takeDown: (
    artistId: string,
    releaseId: string,
    title: string,
    isDelete: boolean
  ) => ConfirmTakedownRelease;
  goBack: () => CallHistoryMethodAction;
}

const mapStateToProps = (state: AppState) => ({
  artistId: state.artist.active?.id,
  releaseId: state.release.release?.id,
  releaseTitle: state.release.release?.title,
  releaseStatus: state.release.release?.status,
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  takeDown: (
    artistId: string,
    releaseId: string,
    title: string,
    isDelete: boolean
  ) =>
    dispatch(new ConfirmTakedownRelease(artistId, releaseId, title, isDelete)),
  goBack: () => dispatch(push('../edit')),
});

export const NavbarActionsUpgradeCtrl: React.FC<NavbarActionsUpgradeCtrlProps> = (
  props
) => {
  // if (!(props.artistId && props.releaseId)) {
  //   return null;
  // }

  // if (!["pending", "pending-processing", "published", "taken-down"].includes(props.releaseStatus)) {
  //   return null;
  // }

  return (
    <div className={props.className}>
      <div className="release-navbar">
        {!props.isMobile && (
          <NavbarItemAvatarCtrl className="navbar-artist" noHover noIcons />
        )}
        {!props.disableTakeDown &&
        !['taken-down', 'pending', 'pending-processing'].includes(
          props.releaseStatus
        ) ? (
          <Button
            className="navbar-artist-btn"
            buttonType="secondary"
            small
            onClick={() => null}
          >
            <Typography className="item-title" weight="700">
              <Translate id="RELEASE.CANCEL" />
            </Typography>
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(NavbarActionsUpgradeCtrl)`
  width: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    width: auto;
  }

  .navbar-artist-btn {
    margin-left: 30px;
  }

  .release-navbar {
    display: flex;
    align-items: center;

    .status {
      margin: 0 35px 0 9px;
    }
  }
`);
